import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCqt9h97U4Rlz8ipEBYdLG9XhB_AJuFSfw",
  authDomain: "elonyklub.firebaseapp.com",
  projectId: "elonyklub",
  storageBucket: "elonyklub.firebasestorage.app",
  messagingSenderId: "380625527456",
  appId: "1:380625527456:web:f01d5a6caccbb8e68edfc5",
  measurementId: "G-KW98XS1139"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
 